export const GET_ALL_HOLIDAYS = "get_all_holidays";
export const RESET_GET_ALL_HOLIDAYS = "reset_get_all_holidays";
export const GET_ALL_HOLIDAYS_SUCCESS = "get_all_holidays_success";
export const GET_ALL_HOLIDAYS_FAILURE = "get_all_holidays_failure";
